module.exports = __webpack_public_path__ + "img/BB.5dfd8e9f.svg";